module.exports = __webpack_public_path__ + "img/ic-pay.1f18e5a4.png";